export default class CoreBlockComponentMap {
  constructor({ ids, map }) {
    this.ids = ids;
    this.map = map;
  }
}
